const mutations = {
  SET_LANG: (state, payload) => {
    state.lang = payload;
  },
  SET_LOAD: (state, payload) => {
    state.load = payload;
  },
  SET_COLOR: (state, payload) => {
    state.color = payload;
  },
  SET_PAGE_SCROLLED: (state, payload) => {
    state.page.scrolled = payload;
  },
  NEXT_SLIDE: (state) => {
    if (state.slider.current >= 3) {
      state.slider.current = 0;
    } else {
      state.slider.current += 1;
    }
  },
  PREV_SLIDE: (state) => {
    if (state.slider.current <= 0) {
      state.slider.current = 3;
    } else {
      state.slider.current -= 1;
    }
  },
  SET_SLIDING: (state, payload) => {
    state.isSliding = payload;
  },
  SET_MENU_OPEN: (state, payload) => {
    state.menu.open = payload;
  },
  TOGGLE_SOUND: (state) => {
    state.sound = !state.sound;
  },
  SAVE_BOTTLES: (state, payload) => {
    payload.archive.items.forEach((bottle) => {
      state.bottles[bottle.slug] = bottle;
    });
  },
  SAVE_BLOG: (state, payload) => {
    payload.archive.items.forEach((post) => {
      state.posts[post.slug] = post;
    });
  },
  SET_NAVIGATING: (state, payload) => {
    state.navigating = payload;
  },
};

export default mutations;
